import Vue from "vue";
import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";
import InfoRequest from "@Scripts/Components/InfoRequest/InfoRequest.vue";
import InfoRequestCta from "@Scripts/Components/InfoRequest/InfoRequestCta.vue";
import ApplicationCta from "@Scripts/Components/InfoRequest/ApplicationCta.vue";

import ExpMenu from "@Scripts/Directives/ExpMenu/ExpMenu";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-cookietoast", CookieToast);
        Vue.component("app-inforequest", InfoRequest);
        Vue.component("app-inforequestcta", InfoRequestCta);
        Vue.component("app-applicationcta", ApplicationCta);
    }

    public static AddDirectives() {
        Vue.directive("exp-menu", ExpMenu);
    }
}